import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { RailTypes } from "../../../../../../component-creators/rails";
import { Icon, Icons } from "../../../../../atoms/icon";
import { Link, LinkKind } from "../../../../../atoms/link";
import { HeaderVariants, Tags, Typography, } from "../../../../../atoms/typography";
import { KebabMenuContinueWatch, } from "../../../../kebab-menu-continue-watch";
import { Favorite } from "../../../../../molecules/favorites";
import { useUser } from "../../../../../../utils/hooks";
import Strings from "../../../../../../utils/hardcoded.json";
import styles from "../styles.css";
const OverlayD = ({ railType, descriptionM, kebabMenuItems, isFavorite, read, category, id, webAuthRedirectionUrl, isFavPage, linkHref, route, kebabHandlerContinueWatch, removeFromfavorites, showGenre, name, shouldOpenInNewWindow = true, contentGenre, }) => {
    const { isAnonymous } = useUser();
    // const KidsOverlay = () => {
    //   return (
    //     <div className={styles.hoverOverlay}>
    //       <div className={styles.basicHoverPlayIconWrapper}>
    //         <Icon
    //           type={Icons.PlayIcon}
    //           className={styles.basiCardhoverPlayIcon}
    //         />
    //       </div>
    //     </div>
    //   );
    // };
    const DefaultOverlay = () => {
        return (React.createElement("div", { className: cn(styles.hoverOverlay, {
                [styles.catgoryHoverOverLay]: railType === RailTypes.DescriptiveWithProgress,
                [styles.withBackground]: railType !== RailTypes.DescriptiveWithProgress,
            }) },
            railType === RailTypes.DescriptiveWithProgress && (React.createElement(KebabMenuContinueWatch, { items: kebabMenuItems, kebabMenuItemHandlerCW: kebabHandlerContinueWatch, origin: "DESKTOP" })),
            React.createElement(Link, { href: linkHref, kind: shouldOpenInNewWindow ? LinkKind.external : LinkKind.internal },
                React.createElement("div", { className: styles.basicHoverPlayIconWrapper, id: "#play-icon" },
                    React.createElement(Icon, { type: Icons.HoverPlayIcon, className: styles.basiCardhoverPlayIcon })),
                railType !== RailTypes.DescriptiveWithProgress && (React.createElement("div", { className: styles.hoverWrapper },
                    React.createElement("div", { className: styles.baicHoverContent, id: "#cardTitle" },
                        React.createElement(Typography, { variant: HeaderVariants.headingSix, tag: Tags.h6, classNameM: M.of(styles.basicShowName) },
                            React.createElement(React.Fragment, null, name)),
                        React.createElement("div", { className: styles.basicDescwrapper },
                            React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { variant: HeaderVariants.subHeadTwo, tag: Tags.span, classNameM: M.of(styles.basicShowDesc) },
                                React.createElement("span", { id: "#desc" }, description))), descriptionM)),
                            React.createElement("div", { className: isFavorite ? styles.likeButton : styles.favoriteButton, id: isFavorite ? Strings.LIKE : Strings.UNLIKE },
                                React.createElement(Favorite, { read: read, id: id, isFavorite: isFavorite, anonymous: isAnonymous, type: category, webAuthUrl: webAuthRedirectionUrl, isFavPage: isFavPage, removeFromfavorites: removeFromfavorites, route: route, contentGenre: contentGenre, showGenre: showGenre, name: name })))))))));
    };
    // const Overlay = () => {
    //   switch (theme) {
    //     case THEME.KIDS:
    //       return <DefaultOverlay />;
    //     default:
    //       return <DefaultOverlay />;
    //   }
    // };
    return React.createElement(DefaultOverlay, null);
};
export default OverlayD;

